define('plugin/news/view/NewsItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * News item view
     *
     * @class NewsItemView
     */
    return LayoutView.extend({

        template: '#news_item_view',

        // onDomRefresh: function () {
        //     Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
        //         'page': 'news_details'
        //     });
        // }

    });

});
